import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getAnnouncements } from 'app/gears/announcements/actions/announcementsActions'
import AnnouncementHeadline from 'app/gears/announcements/components/AnnouncementHeadline'
import styled from 'styled-components'

const StyledAnnouncementHeaderDiv = styled.div`
  padding-bottom: .5rem; // Give some breathing room before the transition to the hero image
  text-align: right; // So the headline is closer to the login button
`

/**
 * Fetches and displays the most recent header, meant to be used in the header for LGY, LgyHeader.jsx
 * 
 * @author Alex Clary
 * @since 20.4.5
 */
function AnnouncementsHeader({ getAnnouncements, announcements, isSuccess }) {
  useEffect(
    () => {
      announcements && announcements.length === 0 && getAnnouncements && getAnnouncements()
    },
    [getAnnouncements, announcements]
  )

  return <StyledAnnouncementHeaderDiv className='announcements usa-grid usa-section-dark'>
    {(isSuccess && announcements && announcements.length > 0)
      ? <AnnouncementHeadline announcement={announcements.sort((a, b) => b.beginDate - a.beginDate)[0]} />
      : '' }
  </StyledAnnouncementHeaderDiv>
}

const mapDispatchToProps = {
  getAnnouncements
}

const mapStateToProps = (state) => ({
  ...state.announcementsState
})

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementsHeader)